import axiosClient from '../../services/axiosClient';
import API_CONFIG from '../config/api.js';

// Utiliser axiosClient qui a déjà X-AppApiToken et Authorization configurés
const apiClient = axiosClient;

// Note: Les intercepteurs pour X-AppApiToken et Authorization sont déjà 
// configurés dans axiosClient.js, pas besoin de les redéfinir ici

// Services API
export const authService = {
  login: (credentials) => apiClient.post(API_CONFIG.ENDPOINTS.AUTH.LOGIN, credentials),
  register: (userData) => apiClient.post(API_CONFIG.ENDPOINTS.AUTH.REGISTER, userData),
  logout: () => apiClient.post(API_CONFIG.ENDPOINTS.AUTH.LOGOUT),
  getProfile: () => apiClient.get(API_CONFIG.ENDPOINTS.AUTH.PROFILE),
};

export const userService = {
  getUsers: () => apiClient.get(API_CONFIG.ENDPOINTS.USERS.LIST),
  createUser: (userData) => apiClient.post(API_CONFIG.ENDPOINTS.USERS.CREATE, userData),
  updateUser: (id, userData) => apiClient.put(`${API_CONFIG.ENDPOINTS.USERS.UPDATE}/${id}`, userData),
  deleteUser: (id) => apiClient.delete(`${API_CONFIG.ENDPOINTS.USERS.DELETE}/${id}`),
};

export const paymentService = {
  getPayments: () => apiClient.get(API_CONFIG.ENDPOINTS.PAYMENTS.LIST),
  createPayment: (paymentData) => apiClient.post(API_CONFIG.ENDPOINTS.PAYMENTS.CREATE, paymentData),
  getPaymentMethods: () => apiClient.get(API_CONFIG.ENDPOINTS.PAYMENTS.METHODS),
  initiateWavePayment: (paymentData) => apiClient.post(API_CONFIG.ENDPOINTS.PAYMENTS.WAVE_INITIATE, paymentData, {
    timeout: 30000 // 30 secondes pour Wave
  }),
};

export const categoryService = {
  getCategories: () => apiClient.get(API_CONFIG.ENDPOINTS.CATEGORIES.LIST),
  createCategory: (categoryData) => apiClient.post(API_CONFIG.ENDPOINTS.CATEGORIES.CREATE, categoryData),
  updateCategory: (id, categoryData) => apiClient.put(`${API_CONFIG.ENDPOINTS.CATEGORIES.UPDATE}/${id}`, categoryData),
  deleteCategory: (id) => apiClient.delete(`${API_CONFIG.ENDPOINTS.CATEGORIES.DELETE}/${id}`),
};

export const companyService = {
  getCompanies: () => apiClient.get(API_CONFIG.ENDPOINTS.COMPANIES.LIST),
  createCompany: (companyData) => apiClient.post(API_CONFIG.ENDPOINTS.COMPANIES.CREATE, companyData),
  updateCompany: (id, companyData) => apiClient.put(`${API_CONFIG.ENDPOINTS.COMPANIES.UPDATE}/${id}`, companyData),
  deleteCompany: (id) => apiClient.delete(`${API_CONFIG.ENDPOINTS.COMPANIES.DELETE}/${id}`),
};

export const contactService = {
  // Public endpoint - no authentication required
  sendMessage: (messageData) => apiClient.post(API_CONFIG.ENDPOINTS.CONTACT.SEND, messageData, {
    headers: { 'X-Skip-Auth': true }
  }),
  // Admin endpoints - authentication required
  getMessages: (params) => apiClient.get(API_CONFIG.ENDPOINTS.CONTACT.LIST, { params }),
  markAsRead: (id) => apiClient.patch(API_CONFIG.ENDPOINTS.CONTACT.READ.replace(':id', id)),
  markAsReplied: (id, adminNotes) => apiClient.patch(
    API_CONFIG.ENDPOINTS.CONTACT.REPLY.replace(':id', id),
    { admin_notes: adminNotes }
  ),
};

export default apiClient;
